import RobotoRegular from 'components/widgets/pdf/fonts/Roboto-Regular.ttf';
import RobotoItalic from 'components/widgets/pdf/fonts/Roboto-Italic.ttf';
import NotoSansSC from 'components/widgets/pdf/fonts/NotoSansSC-Regular.ttf';
import NotoSansTC from 'components/widgets/pdf/fonts/NotoSansTC-Regular.ttf';
import NotoSansJP from 'components/widgets/pdf/fonts/NotoSansJP-Regular.ttf';
import NotoSansKR from 'components/widgets/pdf/fonts/NotoSansKR-Regular.ttf';
import NotoSansTH from 'components/widgets/pdf/fonts/NotoSansTH-Regular.ttf';
import Hind from 'components/widgets/pdf/fonts/Hind-Regular.ttf';

export const LANGUAGES_TO_FONTS_MAP = {
  'zh-CN': {
    family: 'NotoSansSC',
    src: NotoSansSC
  },
  'zh-TW': {
    family: 'NotoSansTC',
    src: NotoSansTC
  },
  'ja-JP': {
    family: 'NotoSansJP',
    src: NotoSansJP
  },
  'ko-KR': {
    family: 'NotoSansKR',
    src: NotoSansKR
  },
  'th-TH': {
    family: 'NotoSansTH',
    src: NotoSansTH
  },
  'hi-IN': {
    family: 'Hind',
    src: Hind
  },
  default: {
    family: 'Roboto',
    src: {
      regular: RobotoRegular,
      italic: RobotoItalic
    }
  }
};
